export default "__VITE_ASSET__BNl5OWUj__"